import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useId, useState } from "react";
import classnames from "classnames";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { Label, Preloader } from "../common/index.js";
import { Box } from "../../Box/index.js";
import { Button } from "../../Button/index.js";
import { Icon } from "../../Icon/index.js";
import MultipleTextInput_styles from "./MultipleTextInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleTextInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleTextInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const MultipleTextInput = (t0)=>{
    const $ = c(87);
    let id;
    let label;
    let labelIcon;
    let onChange;
    let placeholder;
    let rest;
    let t1;
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let tooltip;
    if ($[0] !== t0) {
        ({ id, testId, type: t1, label, labelIcon, values: t2, placeholder, max: t3, onChange, onFocus: t4, onBlur: t5, tooltip, error: t6, helperText: t7, required: t8, disabled: t9, loading: t10 } = t0), rest = _object_without_properties(t0, [
            "id",
            "testId",
            "type",
            "label",
            "labelIcon",
            "values",
            "placeholder",
            "max",
            "onChange",
            "onFocus",
            "onBlur",
            "tooltip",
            "error",
            "helperText",
            "required",
            "disabled",
            "loading"
        ]);
        $[0] = t0;
        $[1] = id;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = onChange;
        $[5] = placeholder;
        $[6] = rest;
        $[7] = t1;
        $[8] = t10;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
        $[17] = testId;
        $[18] = tooltip;
    } else {
        id = $[1];
        label = $[2];
        labelIcon = $[3];
        onChange = $[4];
        placeholder = $[5];
        rest = $[6];
        t1 = $[7];
        t10 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        t6 = $[13];
        t7 = $[14];
        t8 = $[15];
        t9 = $[16];
        testId = $[17];
        tooltip = $[18];
    }
    const type = void 0 === t1 ? "text" : t1;
    let t11;
    if ($[19] !== t2) {
        t11 = void 0 === t2 ? [] : t2;
        $[19] = t2;
        $[20] = t11;
    } else t11 = $[20];
    const values = t11;
    const max = void 0 === t3 ? 3 : t3;
    const onFocus = void 0 === t4 ? _temp : t4;
    const onBlur = void 0 === t5 ? _temp2 : t5;
    const error = void 0 === t6 ? false : t6;
    const helperText = void 0 === t7 ? "" : t7;
    const required = void 0 === t8 ? false : t8;
    const disabled = void 0 === t9 ? false : t9;
    const loading = void 0 === t10 ? false : t10;
    const { classes } = MultipleTextInput_styles();
    const reactId = useId();
    const inputId = null != id ? id : reactId;
    const [numberOfInputsShown, setNumberOfInputs] = useState(1);
    const counter = Math.max(numberOfInputsShown, values.length);
    let T0;
    let t12;
    let t13;
    let t14;
    let t15;
    if ($[21] !== classes.addButton || $[22] !== classes.adornedEnd || $[23] !== classes.input || $[24] !== classes.inputWrapper || $[25] !== classes.multipleTextInput || $[26] !== counter || $[27] !== disabled || $[28] !== error || $[29] !== helperText || $[30] !== inputId || $[31] !== label || $[32] !== labelIcon || $[33] !== loading || $[34] !== max || $[35] !== onBlur || $[36] !== onChange || $[37] !== onFocus || $[38] !== placeholder || $[39] !== required || $[40] !== rest || $[41] !== testId || $[42] !== tooltip || $[43] !== type || $[44] !== values) {
        const range = new Array(counter).fill(1);
        let t16;
        if ($[50] !== onChange) {
            t16 = (index)=>(e)=>onChange(index, e.target.value);
            $[50] = onChange;
            $[51] = t16;
        } else t16 = $[51];
        const handleChange = t16;
        T0 = FormControl;
        t12 = testId;
        if ($[52] !== classes.multipleTextInput) {
            t13 = classnames(classes.multipleTextInput, "aqa_multiple_text_input");
            $[52] = classes.multipleTextInput;
            $[53] = t13;
        } else t13 = $[53];
        if ($[54] !== inputId || $[55] !== label || $[56] !== labelIcon || $[57] !== required || $[58] !== tooltip) {
            t14 = label && /*#__PURE__*/ jsx(Label, {
                label: label,
                required: required,
                tooltip: tooltip,
                icon: labelIcon,
                inputId: inputId
            });
            $[54] = inputId;
            $[55] = label;
            $[56] = labelIcon;
            $[57] = required;
            $[58] = tooltip;
            $[59] = t14;
        } else t14 = $[59];
        let t17;
        if ($[60] !== classes.addButton || $[61] !== classes.adornedEnd || $[62] !== classes.input || $[63] !== classes.inputWrapper || $[64] !== counter || $[65] !== disabled || $[66] !== error || $[67] !== handleChange || $[68] !== helperText || $[69] !== inputId || $[70] !== label || $[71] !== loading || $[72] !== max || $[73] !== onBlur || $[74] !== onFocus || $[75] !== placeholder || $[76] !== rest || $[77] !== testId || $[78] !== type || $[79] !== values) {
            t17 = (_, index_0)=>{
                const isButtonShown = index_0 === counter - 1 && index_0 + 1 < max;
                return /*#__PURE__*/ jsxs(Box, {
                    className: classnames(isButtonShown && classes.inputWrapper),
                    mb: "16",
                    display: "flex",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            flexGrow: 1,
                            children: /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest), {
                                id: inputId,
                                "data-testid": `${testId}-index-${index_0 + 1}`,
                                classes: {
                                    root: classes.input
                                },
                                className: "qaInputWrapper",
                                value: loading ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : values[index_0] || "",
                                autoComplete: "off",
                                onChange: handleChange(index_0),
                                onFocus: onFocus,
                                onBlur: onBlur,
                                fullWidth: true,
                                type: type,
                                error: error,
                                helperText: helperText,
                                placeholder: placeholder || label,
                                disabled: disabled || loading,
                                slotProps: {
                                    input: _object_spread({
                                        className: "textFieldInput",
                                        classes: {
                                            adornedEnd: classes.adornedEnd
                                        }
                                    }, loading ? {
                                        endAdornment: /*#__PURE__*/ jsx(Preloader, {})
                                    } : {})
                                }
                            }))
                        }),
                        isButtonShown && /*#__PURE__*/ jsx(Box, {
                            ml: "20",
                            children: /*#__PURE__*/ jsx(Button, {
                                className: classes.addButton,
                                size: "large",
                                onClick: ()=>setNumberOfInputs(_temp3),
                                icon: /*#__PURE__*/ jsx(Icon, {
                                    name: "add_outline",
                                    size: "24"
                                }),
                                disabled: disabled || loading
                            })
                        })
                    ]
                }, index_0);
            };
            $[60] = classes.addButton;
            $[61] = classes.adornedEnd;
            $[62] = classes.input;
            $[63] = classes.inputWrapper;
            $[64] = counter;
            $[65] = disabled;
            $[66] = error;
            $[67] = handleChange;
            $[68] = helperText;
            $[69] = inputId;
            $[70] = label;
            $[71] = loading;
            $[72] = max;
            $[73] = onBlur;
            $[74] = onFocus;
            $[75] = placeholder;
            $[76] = rest;
            $[77] = testId;
            $[78] = type;
            $[79] = values;
            $[80] = t17;
        } else t17 = $[80];
        t15 = range.map(t17);
        $[21] = classes.addButton;
        $[22] = classes.adornedEnd;
        $[23] = classes.input;
        $[24] = classes.inputWrapper;
        $[25] = classes.multipleTextInput;
        $[26] = counter;
        $[27] = disabled;
        $[28] = error;
        $[29] = helperText;
        $[30] = inputId;
        $[31] = label;
        $[32] = labelIcon;
        $[33] = loading;
        $[34] = max;
        $[35] = onBlur;
        $[36] = onChange;
        $[37] = onFocus;
        $[38] = placeholder;
        $[39] = required;
        $[40] = rest;
        $[41] = testId;
        $[42] = tooltip;
        $[43] = type;
        $[44] = values;
        $[45] = T0;
        $[46] = t12;
        $[47] = t13;
        $[48] = t14;
        $[49] = t15;
    } else {
        T0 = $[45];
        t12 = $[46];
        t13 = $[47];
        t14 = $[48];
        t15 = $[49];
    }
    let t16;
    if ($[81] !== T0 || $[82] !== t12 || $[83] !== t13 || $[84] !== t14 || $[85] !== t15) {
        t16 = /*#__PURE__*/ jsx("div", {
            children: /*#__PURE__*/ jsxs(T0, {
                "data-testid": t12,
                className: t13,
                children: [
                    t14,
                    t15
                ]
            })
        });
        $[81] = T0;
        $[82] = t12;
        $[83] = t13;
        $[84] = t14;
        $[85] = t15;
        $[86] = t16;
    } else t16 = $[86];
    return t16;
};
function _temp() {}
function _temp2() {}
function _temp3(state) {
    return state + 1;
}
export { MultipleTextInput };
